import { Pipe, PipeTransform } from '@angular/core';
import { FieldColumns } from '../../enums/field-columns';
import { FieldType } from '../../enums/field-type';
import { FormAllData, FormStep } from '../../interfaces/forms/form-element';

@Pipe({
    name: 'fieldColumns',
    standalone: false
})
export class FieldColumnsPipe implements PipeTransform {
  transform(elem: FormAllData | FormStep): string {
    const el = elem as FormAllData;
    return (
      el.col ||
      (el.typeInterface === FieldType.TITLE
        ? FieldColumns.FULL
        : FieldColumns.HALF)
    );
  }
}
